<template>
  <table class="table table-sm text-center">
    <thead>
    <tr>
      <th>{{ $t('Auto Bid') }}</th>
      <th>{{ $t('Amount') }}</th>
      <th>{{ $t('Time') }}</th>
      <th>{{ $t('Bidder') }}</th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="(bid, ind) of bids">
      <td class="text-center" v-if="bid.type === 'auto'">
        <font-awesome-icon class="text-success"  icon="check-circle"/>
      </td>
      <td class="text-center" v-if="bid.type !== 'auto'">
      </td>
      <td>{{ bid.amount | asCurrency(lot.currency.symbol) }}</td>
      <td>{{ bid.created_at | toDateTime }}</td>
      <td>{{ bid.bidder.paddle_number }} {{ bid.bidder.customer.display_name }}</td>
    </tr>
    </tbody>
  </table>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";

  const {mapState, mapActions} = createNamespacedHelpers('liveLotsPerformance');

  export default {
    name: "LlpBidsTable",
    props: {
      lot: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapState(['liveBids']),
      bids() {
        let data = this.liveBids.find(el => el.lot_uuid === this.lot.uuid);
        return data ? data.bids : [];
      }
    },
    methods: {
      ...mapActions(['getLiveBids']),
    },
    beforeMount() {
      this.getLiveBids(this.lot);
    },
    beforeDestroy() {
      let existing = this.liveBids.findIndex(el => el.lot_uuid === this.lot.uuid);
      if (existing !== -1) {
        this.liveBids.splice(existing, 1);
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
